import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EmpresasService} from "../../superadmin/services/empresas.service";

import {
  CadPausasProgramadasComponent
} from "../../compartilhado/cad-pausas-programadas/cad-pausas-programadas.component";

@Component({
  selector: 'app-modal-fechar-loja',
  templateUrl: './modal-fechar-loja.component.html',
  styleUrls: ['./modal-fechar-loja.component.scss']
})
export class ModalFecharLojaComponent extends  CadPausasProgramadasComponent implements OnInit  {
  @Input() empresa: any = {};
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onFecharModal: any = new EventEmitter();
  // Adicionar nova propriedade
  intervaloSelecionado: number | null = null;
  intervalos = [
    { valor: 15, label: '15 minutos' },
    { valor: 30, label: '30 minutos' },
    { valor: 60, label: '1 hora' },
    { valor: 180, label: '3 horas' },
    { valor: 360, label: '6 horas' },
    { valor: 720, label: '12 horas' }
  ];

  dataFutura: Date = new Date();
  horaFutura = '00:00';

  salvando = false;
  excluindo = false;
  tipoFechamentoSelecionado: 'agora' | 'intervalo' | 'agendar' | null = null;

  msgErro: string;
  constructor(protected empresasService: EmpresasService) {
    super(empresasService)
  }

  ngOnInit() {  }

  onSalvar() {
     delete this.mensagemErroIntervalo;
     delete this.mensagemErro;
    if(this.agendamento()){
      let erroAgendamento = this.agendarFechamento()

      if(erroAgendamento){
        this.mensagemErro = erroAgendamento
        return;
      }
    }

    if(this.fecharAgora()){
      this.pausaProgramada.descricao = 'Fechado pelo lojista hoje'
      this.pausaProgramada.dataFim = null
      this.pausaProgramada.fecharHoje = true
    }

    if (this.intervalo()) {
      if( this.intervaloSelecionado){
        if(!this.pausaProgramada.descricao)
          this.pausaProgramada.descricao = `Fechado pelo lojista por ${this.intervaloSelecionado} min`

        this.pausaProgramada.dataFim =   new Date();
        this.pausaProgramada.dataFim.setMinutes(new Date().getMinutes() + this.intervaloSelecionado);

      } else {
        this.mensagemErroIntervalo = 'Selecione um dos intervalos';
        return;
      }
    }

    super.onSalvar();
  }

  // Modificar o método existente ou adicionar novo
  selecionarIntervalo(valor: number) {
    this.intervaloSelecionado = valor;
  }

  fecharAgora() {
    return this.tipoFechamentoSelecionado === 'agora';
  }


  agendamento(){
    return this.tipoFechamentoSelecionado === 'agendar'
  }

  intervalo(){
    return this.tipoFechamentoSelecionado === 'intervalo';
  }

  agendarFechamento() {
    if(!this.pausaProgramada.horaInicio || !this.pausaProgramada.horaFim) return;

    this.pausaProgramada.dataInicio.setHours(this.pausaProgramada.horaInicio.getHours(),
                            this.pausaProgramada.horaInicio.getMinutes(), 0, 0);

    // Configura data e hora de reabertura (se preenchido)
    if (this.pausaProgramada.horaFim)
      this.pausaProgramada.dataFim.setHours( this.pausaProgramada.horaFim.getHours(),
            this.pausaProgramada.horaFim.getMinutes(), 0, 0);

    // Validação básica
    if (this.pausaProgramada.dataFim < this.pausaProgramada.dataInicio)
      return 'Data fim tem ser depois da data inicio';


  }

  selecionarTipoFechamento(tipo: 'agora' | 'intervalo' | 'agendar') {
    this.tipoFechamentoSelecionado = tipo;


    this.pausaProgramada.fecharKeeta = this.fecharAgora()  && this.empresa.integracoesKeeta?.length;

  }

  voltarSelecao() {
    this.tipoFechamentoSelecionado = null;
  }

  fechar(fechou: boolean = false) {
    this.onFecharModal.emit({ fechou: fechou });
  }

  fecheComDelay() {
    setTimeout( () => {
      this.fechar()
    }, 300)
  }
}
